<au-custom-dialog
  dialogTitle="Update Password"
  [isDialogVisible]="toggleChangePassword"
  submitButtonText="Submit"
  cancelButtonText="Cancel"
  [loading]="!!(isRequestInProgress$ | async)"
  [isSubmitButtonDisabled]="
    (isRequestInProgress$ | async) === true ||
    password.value !== passwordRepeat.value
  "
  (cancelChange)="cancelChangePassword()"
  (submitChange)="sendChangePasswordRequest()"
>
  <form [formGroup]="form" class="p-fluid grid w-full m-0 p-0">
    <!-- Current Password -->
    <div class="field col-12">
      <label for="currentPassword" class="block mb-2">
        Current Password <span class="required-marker">*</span>
      </label>
      <p-password
        id="currentPassword"
        formControlName="currentPassword"
        [feedback]="false"
        [toggleMask]="true"
        inputStyleClass="w-full"
        class="p-input-icon-right"
      ></p-password>
      <me-form-validation-message
        controlName="currentPassword"
        label="Current password"
      ></me-form-validation-message>
    </div>

    <!-- New Password -->
    <div class="field col-12">
      <label for="password" class="block mb-2">
        New Password <span class="required-marker">*</span>
      </label>
      <p-password
        id="password"
        formControlName="password"
        [strongRegex]="strongRegex"
        (onFocus)="handleFocusBlurEvents($event)"
        (onBlur)="handleFocusBlurEvents($event)"
        [toggleMask]="true"
        inputStyleClass="w-full"
        appendTo="body"
        class="p-input-icon-right"
      >
        <ng-template #header>
          <span class="subtitle-small text-secondary"> Pick a password </span>
        </ng-template>
        <ng-template #footer>
          <p-divider></p-divider>
          <me-password-rules [passwordControl]="password"></me-password-rules>
        </ng-template>
      </p-password>
      @if (showPasswordErrors) {
        <me-form-validation-message
          controlName="password"
          label="New password"
        ></me-form-validation-message>
      }
    </div>

    <!-- Confirm New Password -->
    <div class="field col-12">
      <label for="passwordRepeat" class="block mb-2">
        Confirm New Password <span class="required-marker">*</span>
      </label>
      <p-password
        id="passwordRepeat"
        formControlName="passwordRepeat"
        [feedback]="false"
        [toggleMask]="true"
        inputStyleClass="w-full"
        class="p-input-icon-right"
      ></p-password>
      @if (showPasswordErrors) {
        <me-form-validation-message
          controlName="passwordRepeat"
          label="Confirm new password"
          [displayGroupErrors]="true"
        ></me-form-validation-message>
      }
    </div>
  </form>
</au-custom-dialog>
